<template>
  <div class="freight" v-loading="loading">
    <div class="freight-block">
      <div class="freight-block-top" @click="additionBtn">
        <img
          class="freight-block-top-img"
          src="../../assets/common/common-add.png"
        />
        <div class="freight-block-top-text">添加</div>
      </div>
    </div>

    <div class="freight-table">
      <el-table
        :data="tableData"
        border
        style="width: 100%; cursor: pointer"
        :header-cell-style="{
          color: '#333333',
          backgroundColor: '#FAFAFA',
        }"
      >
        <!-- 自定义暂无数据 -->
        <template slot="empty">
          <div class="empty-block">
            <img
              class="empty-block-img"
              src="../../assets/common/common-empty.png"
            />
            <div class="empty-block-text">暂无数据～</div>
          </div>
        </template>

        <el-table-column label="模板名称">
          <template slot-scope="scope">
            <div>{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop label="开通地区">
          <template slot-scope="scope">
            <div class="table-open" @click="openareaBtn(scope.row)">
              开通地区设置
            </div>
          </template>
        </el-table-column>
        <el-table-column prop label="计算规则">
          <template slot-scope="scope">
            <div
              class="table-open"
              :style="{ color: checkedCities.length == 0 ? '#999' : '' }"
              @click="freeshippingBtn(scope.row.id)"
            >
              查看
            </div>
          </template>
        </el-table-column>

        <el-table-column prop label="操作">
          <template slot-scope="scope">
            <div class="table-operation">
              <div class="compile" @click="compileBtn(scope.row)">编辑</div>
              <div class="delete" @click="deteleBtn(scope.row)">删除</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--添加弹窗-->
    <div class="addition">
      <el-dialog :visible.sync="additionDialogVisible" style="margin-top: 10vh">
        <span slot="footer" class="dialog-footer">
          <div class="addition-div">
            <div class="addition-div-top">
              <div class="addition-div-top-title">添加</div>
              <img
                class="addition-div-top-img"
                src="../../assets/common/close.png"
                @click="additionDialogVisible = false"
              />
            </div>

            <div class="addition-div-center">
              <div class="addition-div-center-display">
                <div class="addition-div-center-display-left">
                  <div class="display-left-title">模板名称</div>
                  <div class="display-left-input">
                    <el-input
                      placeholder="请输入模板名称"
                      v-model="additionModule"
                      clearable
                    ></el-input>
                  </div>
                </div>
                <!-- <div class="addition-div-center-display-right">
                    <div class="display-right-title">运费类型</div>
                    <div class="display-right-select">
                      <el-select v-model="additionLogistics" placeholder="请选择">
                        <el-option
                          v-for="item in additionFreightList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div> -->
              </div>
            </div>

            <div class="addition-div-button">
              <!-- <div class="addition-div-button-left">重 置</div> -->
              <div class="addition-div-button-right" @click="saveBtn">
                确 定
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!-- 开通弹出框 -->
    <div class="openArea">
      <el-dialog :visible.sync="openAreaDialogVisible">
        <span slot="footer" class="dialog-footer">
          <div class="openArea-div">
            <div class="openArea-div-top">
              <div class="openArea-div-top-title">开通地区</div>
              <img
                class="openArea-div-top-img"
                src="../../assets/common/close.png"
                @click="openAreaDialogVisible = false"
              />
            </div>

            <div class="openArea-div-center">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
              <div style="margin: 15px 0"></div>
              <el-checkbox-group
                v-model="checkedCities"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  v-for="(item, index) in openAreaData"
                  :label="item"
                  :key="index"
                  :disabled="item.is_role == 1 ? false : true"
                  >{{ item.district }}</el-checkbox
                >
              </el-checkbox-group>

              <!-- <el-tree
                    :data="openAreaData"
                    :render-content="renderContent"
                    show-checkbox
                    node-key="id"
                    ref="tree"
                    highlight-current
                    default-expand-all
                    @check-change="handleClick"
                    :props="openAreaDefaultProps"
                ></el-tree>-->
            </div>

            <div class="openArea-div-button">
              <div class="openArea-div-button-left" @click="openClose">
                取 消
              </div>
              <div class="openArea-div-button-right" @click="openAreaConfirm">
                确 定
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--计算规则 -->
    <div class="calculate">
      <el-dialog
        :visible.sync="freeshippingDialogVisible"
        style="margin-top: 10vh"
      >
        <!-- 计算规则 内部嵌套弹窗 -->
        <span slot="footer" class="dialog-footer">
          <div class="calculate-div">
            <div class="calculate-div-top">
              <div class="calculate-div-top-title">计算规则</div>
              <img
                class="calculate-div-top-img"
                src="../../assets/common/close.png"
                @click="freeshippingDialogVisible = false"
              />
            </div>
            <!-- <div class="calculate-div-warning">抱歉，该运费模板类型为按重量计费，目前还有地区运费未设置，请及时查看设置。</div> -->
            <div class="calculate-div-center">
              <div class="calculate-div-center-addition">
                <div
                  class="calculate-div-center-addition-left"
                  @click="addtionBtn(0)"
                >
                  <img
                    class="calculate-div-center-addition-left-img"
                    src="../../assets/common/common-add.png"
                  />
                  <div class="calculate-div-center-addition-left-text">
                    地区运费添加
                  </div>
                </div>

                <div class="calculate-div-center-addition-right">
                  <el-select
                    :value="calculateNum"
                    placeholder="数量"
                    @change="calculateChang"
                  >
                    <el-option
                      v-for="item in calculateSelect"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>

              <div class="calculate-div-center-table">
                <el-table
                  :data="calculateData"
                  border
                  style="width: 100%; cursor: pointer"
                  :header-cell-style="{
                    color: '#333333',
                    backgroundColor: '#FAFAFA',
                  }"
                >
                  <!-- 自定义暂无数据 -->
                  <template slot="empty">
                    <div class="empty-block">
                      <img
                        class="empty-block-img"
                        src="../../assets/common/common-empty.png"
                      />
                      <div class="empty-block-text">暂无数据～</div>
                    </div>
                  </template>
                  <el-table-column
                    prop="area"
                    label="地区"
                    width="270"
                  ></el-table-column>
                  <el-table-column prop label="计算规则">
                    <template slot-scope="scope">
                      <div
                        class="table-calculate"
                        @click="freightTem(scope.$index)"
                      >
                        <div class="table-calculate-text">默认运费</div>
                        <div class="table-calculate-block">
                          <el-input
                            placeholder
                            v-model="scope.row.fweight[0]"
                          ></el-input>
                        </div>
                        <div class="table-calculate-text">
                          {{ calculateNum == 0 ? '件' : 'kg' }}以内，
                        </div>
                        <div class="table-calculate-block">
                          <el-input
                            placeholder
                            v-model="scope.row.tweight[0]"
                          ></el-input>
                        </div>
                        <div class="table-calculate-text">元。后续每增加</div>
                        <div class="table-calculate-block">
                          <el-input
                            placeholder
                            v-model="scope.row.fweight[1]"
                          ></el-input>
                        </div>
                        <div class="table-calculate-text">
                          {{ calculateNum == 0 ? '件' : 'kg' }}，增加运费
                        </div>
                        <div class="table-calculate-block">
                          <el-input
                            placeholder
                            v-model="scope.row.tweight[1]"
                          ></el-input>
                        </div>
                        <div class="table-calculate-text">元。</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop label="操作" width="186">
                    <template slot-scope="scope">
                      <div class="table-operation">
                        <!-- <div
                            class="compile"
                            @click="modificationCalculate(scope.row)"
                          >
                            修改地区
                          </div> -->
                        <div
                          class="compile"
                          @click="deteleCalculate(scope.row)"
                        >
                          删除
                        </div>

                        <div
                          class="delete"
                          @click="preserveCalculate(scope.row)"
                        >
                          保存
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <div class="calculate-div-button">
              <div
                class="calculate-div-button-left"
                @click="freeshippingDialogVisible = false"
              >
                取 消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
    <!--计算规则 嵌套逻辑弹窗 -->
    <div class="calculate-openArea">
      <el-dialog :visible.sync="calculateDialogVisibleNest">
        <span slot="footer" class="dialog-footer">
          <div class="calculate-openArea-div">
            <div class="openArea-div-top">
              <div class="openArea-div-top-title">开通地区</div>
              <img
                class="openArea-div-top-img"
                src="../../assets/common/close.png"
                @click="calculateDialogVisibleNest = false"
              />
            </div>

            <!-- <div class="openArea-div-warning">抱歉，该运费模板类型为免运费，最少保持一地区的运费为免运费。</div> -->
            <div class="openArea-div-center">
              <el-checkbox
                :indeterminate="isIndeterminate1"
                v-model="checkAll2"
                @change="handleCheckAllChange1"
                :disabled="freightcheckAll"
                >全选</el-checkbox
              >
              <div style="margin: 15px 0"></div>
              <el-checkbox-group
                v-model="checkedCitiestwo"
                @change="handleCheckedCitiesChange1"
              >
                <el-checkbox
                  v-for="(item, index) in areatwoArray"
                  :label="item"
                  :key="index"
                  :disabled="item.isDisabled"
                  >{{ item.district }}</el-checkbox
                >
              </el-checkbox-group>
              <!-- <el-tree
                    :data="freeshippingData"
                    :render-content="renderContent"
                    show-checkbox
                    node-key="id"
                    ref="tree"
                    highlight-current
                    default-expand-all
                    @check-change="handleClicks"
                    :props="freeshippingDefaultProps"
                ></el-tree>-->
            </div>

            <div class="openArea-div-button">
              <div
                class="openArea-div-button-left"
                @click="calculateDialogVisibleNest = false"
              >
                取 消
              </div>
              <div class="openArea-div-button-right" @click="addressfreeship">
                确 定
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--删除-->
    <div class="detele">
      <el-dialog
        :visible.sync="detDialogVisible"
        style="margin-top: 15vh"
        :show-close="false"
      >
        <span slot="footer" class="dialog-footer">
          <div class="detele-div">
            <img
              class="detele-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="detele-div-title">确定是否删除该运费模板？</div>
            <div class="detele-div-text">
              删除该运费模板会导致使用该运费模板的商品进行下架至仓库
            </div>
            <div class="detele-div-button">
              <div class="detele-div-button-left" @click="deletefreight">
                确定
              </div>
              <div
                class="detele-div-button-right"
                @click="detDialogVisible = false"
              >
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!-- 编辑或者添加 嵌套保存 -->
    <div class="save">
      <el-dialog
        :visible.sync="saveDialogVisibleNest"
        style="margin-top: 15vh"
        :show-close="false"
      >
        <span slot="footer" class="dialog-footer">
          <div class="save-div">
            <img
              class="save-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="save-div-title">请重新确定是否保存？</div>
            <div class="save-div-text">
              一旦保存成功，“开通地区”和“计算规则”设置 将清空
            </div>
            <div class="save-div-button">
              <div class="save-div-button-left" @click="addsupplier">确定</div>
              <div
                class="save-div-button-right"
                @click="saveDialogVisibleNest = false"
              >
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!-- 切换提交 -->
    <div class="detele">
      <el-dialog
        :visible.sync="numDialogVisibleNest"
        style="margin-top: 15vh"
        :show-close="false"
      >
        <span slot="footer" class="dialog-footer">
          <div class="detele-div">
            <img
              class="detele-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="detele-div-title">
              {{ calculateNumStr == 1 ? '数量切换kg' : 'kg切换数量' }}
            </div>
            <div class="detele-div-text1">
              {{
                calculateNumStr == 1
                  ? '若计算单位切换成功，涉及该运费模板的的商品在重量未设置的前提下会进行强制下架。是否确定切换计算单位'
                  : '是否确定切换计算单位？'
              }}
            </div>
            <div class="detele-div-button">
              <div class="detele-div-button-left" @click="numfreight">确定</div>
              <div class="detele-div-button-right" @click="colsefreight">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

    <script>
import {
  getfreight,
  getarea,
  postfreight,
  deletefreight,
  getrule,
  postrule,
  postareano,
  deletefnRule,
  postareayes,
} from '../../api/supplier'
import { isNotNull } from '../../utils/componet'
import Bus from '../../utils/bus' // bus发送跳转关闭临时组件
export default {
  data() {
    return {
      id: '', //供应商id
      // 监听用户刷新
      loading: false,
      // 第一区域 表格数据
      tableData: [
        {
          A: 'nike公司',
          B: '顺丰快递',
          C: '免运费',
        },
      ],
      // 第一区域 添加弹窗
      additionDialogVisible: false,
      // 第一区域 删除弹出框
      detDialogVisible: false,
      // 添加弹出框 模板名称
      additionModule: '',
      // 添加弹出框 物流快递
      additionLogisticsList: [
        {
          value: '0',
          label: '黄金糕',
        },
        {
          value: '1',
          label: '双皮奶',
        },
        {
          value: '2',
          label: '蚵仔煎',
        },
        {
          value: '3',
          label: '龙须面',
        },
        {
          value: '4',
          label: '北京烤鸭',
        },
      ],
      // 添加弹出框 物流快递选中
      additionLogistics: '',
      // 添加弹出框 运费类型
      additionFreight: '',
      // 添加弹出框 运费类型数组
      additionFreightList: [
        {
          value: '0',
          label: '免运费',
        },
        {
          value: '1',
          label: '重量计费',
        },
        {
          value: '2',
          label: '数量计费',
        },
      ],
      // 开通地区的弹出框
      openAreaDialogVisible: false,

      // 开通地区弹出框所有区域全部选中后进行全选 树形结构算法
      openAreaData: [],
      openAreaDefaultProps: {
        children: 'districtList',
        label: 'district',
      },
      // 开通地区弹出框所有区域全部选中后进行全选 树形结构勾选存储
      openAreaArray: [],

      openAreaArray2: [],
      // 计算规则弹出框
      freeshippingDialogVisible: false,
      // 计算规则弹出框 添加所有区域全部选中后进行全选 树形结构算法
      freeshippingData: [],
      freeshippingDefaultProps: {
        children: 'districtList',
        label: 'district',
      },
      // 计算规则表格
      calculateData: [],
      calculateDataProps: {
        children: 'area',
        label: 'area',
      },

      // 计算规则弹出框 数量
      calculateNum: 0,
      // 计算规则弹出框 存储
      calculateNumStr: 0,
      // 计算规则弹出框 数量数组
      calculateSelect: [
        {
          value: 0,
          label: '数量',
        },
        {
          value: 1,
          label: 'kg',
        },
      ],
      freeid: '', //运费模板id
      addresslist: [], //非免邮地区
      checkAll: false,
      checkAll2: false,
      checkedCities: [],

      // 二次开启弹出框存储数组
      areatwoArray: [],
      checkedCitiestwo: [],
      overlist: [
        {
          id: '',
          district_id: '',
          unit: '',
          type: '',
          fweight: '',
          tweight: '',
        },
      ],
      postid: '',
      isIndeterminate: false,
      isIndeterminate1: false,
      // 计算规则弹出框 内部嵌套弹出框
      calculateDialogVisibleNest: false,
      // 添加编辑 保存
      saveDialogVisibleNest: false,
      addressid: '', //选中的地区id
      copyid: '', //编辑的id
      cup: '', //编辑还是添加
      // 获取修改地区的规则id
      regionalRuleId: '',
      // 获取当前选中的下标
      freightIndex: 0,
      // 当前列表中所有地区字符串
      freightStr: '',
      // 判断当前二级开通地区全部勾选后禁止点击全选
      freightcheckAll: false,
      // 切换数量或者重量
      numDialogVisibleNest: false,
    }
  },
  created() {
    this.id = this.$route.query.id
    this.loading = true
    this.index()
  },
  // 控制页面刷新或者挂载完后进行权限开启
  updated() {
    if (this.id == undefined) {
      Bus.$emit('detele', 'supplierFreightset')
    }
  },
  methods: {
    index() {
      let params = {
        freightName: '',
        supplierId: this.id,
      }
      getfreight(params).then((res) => {
        if (res) {
          this.tableData = res.resultData.freightList
          this.loading = false
        }
      })
    },
    // 点击添加
    additionBtn() {
      // 模块名称
      this.additionModule = ''
      // 物流快递
      this.additionLogistics = ''
      // id
      this.copyid = ''
      // 运费计算
      this.additionFreight = ''
      this.additionDialogVisible = true
    },
    /* 编辑 */
    // 开启编辑弹出框
    compileBtn(index) {
      // 模块名称
      this.additionModule = index.name
      // 物流快递
      this.additionLogistics = '0'
      // 运费计算
      this.copyid = index.id || ''
      this.additionFreight = '1'
      this.additionDialogVisible = true
    },
    // 开启删除弹出框
    deteleBtn(index) {
      this.detDialogVisible = true
      this.deleteid = index.id
    },
    //删除运费模板
    deletefreight() {
      let params = this.deleteid
      deletefreight(params).then((res) => {
        if (res.resultStatus == true) {
          this.detDialogVisible = false
          // this.$message({
          //   message: '删除成功！',
          //   type: 'success',
          //   duration: 2000
          // })

          this.loading = true
          this.index()
        }
      })
    },

    //
    /* 开通地址的全选操作 */
    // 开启开通地址弹出框  开关
    openareaBtn(index) {
      this.loading = true
      this.freeid = index.id
      let params = {
        expressfeeid: this.freeid, // 运费模板id
        expressfeecity_b_id: '', //
      }
      getarea(params).then((res) => {
        if (res) {
          res.resultData.forEach((item, index) => {
            item.disabled = true
          })
          this.openAreaData = res.resultData
          this.loading = false
          this.checkedCities = []
          this.isIndeterminate = false

          res.resultData.forEach((item, index) => {
            if (item.is_use == 1) {
              this.checkedCities.push(item)
              this.isIndeterminate = true
            }
          })

          this.openAreaDialogVisible = true

          this.checkAll = false
        }
      })
    },

    // 开通地址树形弹窗结构
    /* 计算规则 */
    // 开启计算规则弹出框
    freeshippingBtn(index) {
      if (this.checkedCities.length == 0) {
        return
      }

      this.freeshippingDialogVisible = true
      this.freeid = index
      let params = {
        id: index, //供应商运费模板id
      }
      getrule(params).then((res) => {
        if (res.resultStatus == true) {
          this.calculateData = res.resultData
          this.calculateNum =
            res.resultData.length == 0 ? 0 : res.resultData[0].unit == 0 ? 1 : 0

          // 组合地址每次调用清空
          console.log('是否还有数据', this.calculateData)

          this.freightStr = ''

          // 获取数组列表中所有地区id
          this.freightStr = this.calculateData
            .map(function (obj, index) {
              return obj.district_id
            })
            .join(';')

          console.log('获取数组中所有的地区id组成字符串', this.freightStr)

          // 每次只要调用这个接口就重新获取一下列表中组合字符串
          this.extra()
          // 对当前选中数组添加禁用值
          this.prohibitBtn()

          if (res.resultData == !isNotNull) {
          } else {
            this.addressid = this.calculateData[0].district_id
            this.postid = this.calculateData[0].id
            console.log('开启计算规则弹出框', this.calculateData)
          }
        }
      })
    },

    // 计算规则弹出框内部嵌套 总体数量
    calculateChang(e) {
      console.log(e)
      this.numDialogVisibleNest = true
      console.log('选中', e)
      this.calculateNumStr = e

      //   console.log(' this.calculateNum',  this.calculateNum)
    },
    // 计算规则切换单位弹出框 确定
    numfreight() {
      this.calculateNum = this.calculateNumStr
      this.numDialogVisibleNest = false
    },

    // 计算规格切换单位弹出框 取消
    colsefreight() {
      this.numDialogVisibleNest = false
    },

    // 计算规则 请重新确定是否保存？
    saveBtn() {
      console.log('判断是否是添加还是编辑', this.copyid)
      // 判断当前id是否有值
      let strId = ''
      // 根据id是否有值
      if (this.copyid == '') {
        strId = ''
      } else {
        strId = this.copyid
      }

      let params = {
        supplier_id: this.id, //供应商id
        id: strId || '', //供应商运费模板id
        name: this.additionModule, //模板名称
        type: this.additionLogistics, //类型:0=免运费,1=按重量计费,2=按数量计费
        force: 1, //是否强制修改 1是
      }
      postfreight(params).then((res) => {
        this.additionDialogVisible = false
        this.saveDialogVisibleNest = false
        this.loading = true
        this.index()
      })
    },
    //添加运费模板
    addsupplier() {
      this.saveBtn()
    },
    // 第一部分  //全选 -------------------------------------
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.openAreaData : []
      this.isIndeterminate = false

      console.log('查询勾选的', this.checkedCities)

      if (val == true) {
      } else {
        this.checkedCities = []
      }
    },
    //单选
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.openAreaData.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.openAreaData.length
      console.log(value, '单选')
      // 单选后放入
      this.checkedCities = value
    },

    // end-----------------------------------------

    // 第二部分  //全选 -------------------------------------
    handleCheckAllChange1(val) {
      this.checkedCitiestwo = val ? this.areatwoArray : []
      this.isIndeterminate1 = false

      if (val == true) {
      } else {
        this.checkedCitiestwo = []
      }
    },
    //第二部分单选
    handleCheckedCitiesChange1(value) {
      let checkedCount = value.length
      this.checkAll2 = checkedCount === this.areatwoArray.length
      this.isIndeterminate1 =
        checkedCount > 0 && checkedCount < this.areatwoArray.length
    },

    // end-----------------------------------------

    // 开启计算规则弹出框 删除
    deteleCalculate(e) {
      console.log('获取当前列表的id', e.id)
      let params = {
        id: e.id,
      }

      deletefnRule(params).then((res) => {
        console.log('获取对应的res', res)
        if (res.resultData == true) {
          this.$message({
            message: '删除成功！',
            type: 'success',
            duration: 2000,
          })

          this.freeshippingBtn(this.freeid)
        }
      })
    },

    // 获取点击当前行
    freightTem(index) {
      console.log('获取当前行下标', index)
      this.freightIndex = index
    },

    // 开启计算规则弹出框 保存
    preserveCalculate(item) {
      console.log('点击保存', item)

      item.expressfeeid = this.freeid
      item.unit = this.calculateNum == 0 ? 1 : 0
      item.type = this.calculateNum == 0 ? 1 : 0
      item.force = 1

      let params = item
      console.log('获取保存数组', params)
      postrule(params).then((res) => {
        if (res.resultStatus == true) {
          this.calculateDialogVisibleNest = false
          this.cup = 0
          this.$message({
            message: '保存成功！',
            type: 'success',
            duration: 2000,
          })
          this.freeshippingBtn(this.freeid)
        }
      })
    },

    // 开通地区确定勾选 确定
    openAreaConfirm() {
      console.log('-----------------------确定勾选')
      let array = []
      this.checkedCities.forEach((item, index) => {
        if (item.is_role == 1) {
          array.push(item)
        }
      })

      console.log('1111', array)

      if (array.length != 0) {
        this.addressid = array
          .map(function (obj, index) {
            return obj.district_id
          })
          .join(';')
      } else {
        this.addressid = ''
        return
      }

      //设置非免邮地区
      let params = {
        id: this.freeid,
        district_id: this.addressid,
      }
      postareano(params).then((res) => {
        if (res.resultStatus == true) {
          this.calculateDialogVisibleNest = false
          this.freeshippingDialogVisible = false
          this.index()
        }
      })
      this.openAreaDialogVisible = false
    },

    // 开通地区 取消
    openClose() {
      this.openAreaDialogVisible = false
    },

    // 开启计算规则弹出框 修改地址
    modificationCalculate(e) {
      console.log('第二步', this.checkedCities)
      console.log('修改地址', e)
      this.addtionBtn(1)
      this.cup = 1
      // 获取修改地区的id
      this.regionalRuleId = e.id

      let strayy = []
      if (typeof e.district_id == 'string') {
        strayy = e.district_id.split(';')
      } else {
        strayy.push(e.district_id)
      }

      console.log('第一步', strayy)

      this.checkedCities.forEach((item, index) => {
        for (let i = 0; i < strayy.length; i++) {
          if (item.district_id == strayy[i]) {
            console.log('id对等')
            item.isDisabled = false
          }
        }
      })
    },

    // 额外计算对应的逻辑规则
    extra() {
      console.log('-----', this.freightStr)

      let strayy = []
      if (typeof this.freightStr == 'string') {
        strayy = this.freightStr.split(';')
      } else {
        strayy.push(this.freightStr)
      }
      this.areatwoArray.forEach((item, index) => {
        for (let i = 0; i < strayy.length; i++) {
          if (item.district_id == strayy[i]) {
            item.isDisabled = true
          }
        }
      })

      console.log('当前模板勾选对应的id', this.areatwoArray)
    },

    // 计算规则弹出框内部嵌套 添加弹窗
    addtionBtn(index) {
      // 1 修改  0 添加
      if (index == 1) {
        this.freightcheckAll = false
      } else {
        console.log('-------第一步添加')
        this.copyid = ''
        this.regionalRuleId = ''
        this.areatwoArray = []
        this.checkedCitiestwo = []

        let params = {
          expressfeeid: this.freeid, // 运费模板id
          expressfeecity_b_id: '', //
        }
        getarea(params).then((res) => {
          if (res.resultStatus == true) {
            let array = []
            res.resultData.forEach((item, index) => {
              if (item.is_use == 1) {
                array.push(item)
              }
            })

            this.areatwoArray = array

            this.extra()
            this.calculateDialogVisibleNest = true
          }
        })
      }
    },

    // 意外计算当前弹出框是否可以全选
    accidentCheck() {
      console.log('111', this.checkedCities)

      let array = []
      this.checkedCities.forEach((item, index) => {
        if (item.isDisabled != true) {
          array.push(item)
        }
      })

      if (array.length == 0) {
        this.freightcheckAll = true
      } else {
        this.freightcheckAll = false
      }

      console.log('查询对应的是否禁止', this.freightcheckAll)
    },

    // 额外添加对当前数组添加禁用值
    prohibitBtn() {
      this.checkedCitiestwo.forEach((item, index) => {
        item.isDisabled = false
      })

      console.log('添加', this.checkedCitiestwo)
    },
    //地区运费添加
    addressfreeship() {
      let array = []
      this.checkedCitiestwo.forEach((item, index) => {
        if (item.isDisabled != true) {
          array.push(item)
        }
      })

      console.log('确定获取勾选的', array)
      console.log('获取规追责id', this.regionalRuleId)

      // 获取当前array数组中没有被禁用的
      console.log('查询array', array)

      if (array.length != 0) {
        this.addressid = array
          .map(function (obj, index) {
            return obj.district_id
          })
          .join(';')
      } else {
        this.addressid = ''
        return
      }

      console.log('-------------------------------地区运费添加-------------')

      console.log('供应商运费模板id', this.freeid)
      console.log('规则id', this.id)
      console.log('地区id 多个;隔开 例如 1;2;3----', this.addressid)
      console.log('单位 0重量 1数量')
      let params = {
        expressfeeid: this.freeid, // 供应商id
        id: this.regionalRuleId || '', // 规则id
        district_id: this.addressid, // 地区id 多个;隔开 例如 1;2;3
        unit: this.calculateNumStr == 1 ? 1 : 2, // 类型:0=免运费,1=按重量计费,2=按数量计费
        type: '', // 单位 0重量 1数量
        fweight: [],
        tweight: [],
      }

      postrule(params).then((res) => {
        if (res.resultStatus == true) {
          this.calculateDialogVisibleNest = false
          this.cup = 0
          this.freeshippingBtn(this.freeid)
        }
      })

      console.log('查询', params)
    },
    // 数组去重
    unique(arr) {
      return Array.from(new Set(arr))
    },
  },
}
</script>

    <style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

:focus-visible {
  outline: -webkit-focus-ring-color auto 1px;
  display: flex;
  flex-wrap: wrap;
}

.freight {
  min-height: 978px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #edeff7;
  border-radius: 10px;
  padding: 0 24px;
  padding-bottom: 24px;
  box-sizing: border-box;

  .freight-block {
    height: 80px;
    display: flex;
    align-items: center;
    .freight-block-top {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 82px;
      height: 36px;
      background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
      border-radius: 10px;
      cursor: pointer;

      .freight-block-top-img {
        width: 13px;
        height: 13px;
      }

      .freight-block-top-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        margin-left: 8px;
      }
    }
  }

  .freight-table {
    /deep/ .el-table .el-table__cell {
      vertical-align: top;
    }
    /deep/ .el-table thead {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
      background: #d8d8d8;
    }

    /deep/ .el-table tr {
      height: 46px;
    }

    /deep/ .el-table__empty-text {
      line-height: 0;
    }

    .empty-block {
      margin-top: 62px;
      padding-bottom: 40px;
      .empty-block-img {
        width: 130px;
        height: 130px;
        margin: 0 auto;
      }

      .empty-block-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-top: 10px;
        height: 17px;
        line-height: 17px;
      }
    }

    .table-open {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2aa4ff;
      text-decoration: underline;
    }

    .table-operation {
      display: flex;

      .compile,
      .delete {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
      }

      .delete {
        margin-left: 24px;
      }
    }
  }

  /* 添加弹出框 */
  .addition {
    /deep/ .el-dialog {
      width: 590px;
      height: 208px;
      background: #ffffff;
      box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
        0px 9px 28px 0px rgba(0, 0, 0, 0.05),
        0px 6px 16px -8px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }

    .addition-div {
      .addition-div-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #d9d9d9;
        .addition-div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }

        .addition-div-top-img {
          width: 10px;
          height: 10px;
        }
      }

      .addition-div-center {
        margin-top: 20px;
        padding: 0 24px;
        box-sizing: border-box;
        .addition-div-center-display {
          display: flex;
          margin-bottom: 16px;
          .addition-div-center-display-left {
            width: 100%;
            .display-left-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .display-left-input {
              margin-top: 4px;
              width: 100%;

              /deep/ .el-input {
                height: 32px;
                width: 100%;
              }

              /deep/ .el-input__inner {
                padding: 0 10px;
                box-sizing: border-box;
                height: 32px;
                background-color: rgba(255, 255, 255, 0);
              }
              /deep/ .el-select .el-input.is-focus .el-input__inner {
                border-color: rgba(217, 217, 217, 1);
              }
            }
          }

          .addition-div-center-display-right {
            margin-left: 24px;
            .display-right-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .display-right-select {
              margin-top: 4px;
              width: 254px;
              /deep/ .el-input {
                height: 32px;
                width: 254px;
              }

              /deep/ .el-input__inner {
                padding: 0 10px;
                box-sizing: border-box;
                height: 32px;
                background-color: rgba(255, 255, 255, 0);
              }

              /deep/ .el-select .el-input.is-focus .el-input__inner {
                border-color: rgba(217, 217, 217, 1);
              }
            }
          }
        }
      }

      .addition-div-button {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 24px;
        box-sizing: border-box;
        height: 52px;
        border-top: 1px solid #e9edf4;
        margin-top: 22px;

        .addition-div-button-left,
        .addition-div-button-right {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          text-align: center;
          line-height: 32px;
          cursor: pointer;
        }

        .addition-div-button-right {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          margin-left: 8px;
          color: #ffffff;
        }
      }
    }
  }
  /* 开通地区弹出框 */
  .openArea {
    /deep/ .el-dialog {
      width: 1190px;
      margin: 4.5vh auto 0 !important;
      box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
        0px 9px 28px 0px rgba(0, 0, 0, 0.05),
        0px 6px 16px -8px rgba(0, 0, 0, 0.08);
      background: #ffffff;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }

    .openArea-div {
      height: 100%;
      background: #ffffff;
      border-radius: 10px;
      .openArea-div-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #d9d9d9;
        .openArea-div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }

        .openArea-div-top-img {
          width: 10px;
          height: 10px;
        }
      }

      .openArea-div-center {
        padding: 0 24px;
        box-sizing: border-box;

        /deep/ .el-tree-node__content {
          height: 40px;
        }

        /deep/ .el-tree-node__expand-icon.expanded {
          display: none;
        }

        /deep/ .el-tree-node__content > .el-tree-node__expand-icon {
          display: none;
        }

        /deep/ .el-tree-node__label {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }

      .openArea-div-button {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 24px;
        box-sizing: border-box;
        height: 52px;
        border-top: 1px solid #e9edf4;
        margin-top: 22px;

        .openArea-div-button-left,
        .openArea-div-button-right {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          text-align: center;
          line-height: 32px;
          cursor: pointer;
        }

        .openArea-div-button-right {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          margin-left: 8px;
          color: #ffffff;
        }
      }
    }
  }
  /* 计算规则 */
  .calculate {
    /deep/ .el-dialog {
      width: 1190px;
      margin: 4.5vh auto 0 !important;
      background: #ffffff;
      box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
        0px 9px 28px 0px rgba(0, 0, 0, 0.05),
        0px 6px 16px -8px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }
    .calculate-div {
      background: #ffffff;
      border-radius: 10px;
      .calculate-div-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #d9d9d9;
        .calculate-div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }

        .calculate-div-top-img {
          width: 10px;
          height: 10px;
        }
      }

      .calculate-div-warning {
        width: 100%;
        height: 30px;
        background: rgba(249, 182, 60, 0.1);
        line-height: 30px;
        padding: 0 24px;
        box-sizing: border-box;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ed6d1f;
      }

      .calculate-div-center {
        padding: 0 24px;
        box-sizing: border-box;
        .calculate-div-center-addition {
          display: flex;
          height: 66px;
          align-items: center;
          justify-content: space-between;
          .calculate-div-center-addition-left {
            width: 138px;
            height: 36px;
            background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
            border-radius: 10px;
            justify-content: center;
            align-items: center;
            display: flex;
            cursor: pointer;
            .calculate-div-center-addition-left-img {
              width: 13px;
              height: 13px;
            }

            .calculate-div-center-addition-left-text {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              margin-left: 8px;
            }
          }

          .calculate-div-center-addition-right {
            width: 100px;
            height: 32px;

            /deep/ .el-select {
              width: 100%;
            }

            /deep/ .el-input--suffix .el-input__inner {
              height: 32px;
            }

            /deep/ .el-input__suffix {
              display: flex;
              align-items: center;
            }

            /deep/ .el-select .el-input.is-focus .el-input__inner {
              border-color: rgba(217, 217, 217, 1);
            }
          }
        }

        .calculate-div-center-table {
          /deep/ .el-table .el-table__cell {
            padding: 13px 0;
            vertical-align: top;
            box-sizing: border-box;
          }
          /deep/ .el-table thead {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            background: #d8d8d8;
          }

          /deep/ .el-table tr {
            height: 46px;
          }

          /deep/ .el-table__empty-text {
            line-height: 0;
          }

          .empty-block {
            margin-top: 40px;
            padding-bottom: 20px;
            .empty-block-img {
              width: 130px;
              height: 130px;
              margin: 0 auto;
            }

            .empty-block-text {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              margin-top: 10px;
              height: 17px;
              line-height: 17px;
            }
          }

          .table-calculate {
            display: flex;
            height: 100%;
            align-items: center;

            .table-calculate-text {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .table-calculate-block {
              width: 40px;
              height: 32px;
              margin: 0 5px;

              /deep/ .el-input {
                height: 32px;
                width: 40px;
              }

              /deep/ .el-input__inner {
                padding: 0 10px;
                box-sizing: border-box;
                height: 32px;
                background-color: rgba(255, 255, 255, 0);
              }
            }
          }

          .table-operation {
            display: flex;

            .compile,
            .delete {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #2aa4ff;
              text-decoration: underline;
            }

            .delete {
              margin-left: 24px;
            }
          }
        }
      }

      .calculate-div-button {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 24px;
        box-sizing: border-box;
        height: 52px;
        border-top: 1px solid #e9edf4;
        margin-top: 22px;

        .calculate-div-button-left,
        .calculate-div-button-right {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          text-align: center;
          line-height: 32px;
          cursor: pointer;
        }

        .calculate-div-button-right {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          margin-left: 8px;
          color: #ffffff;
        }
      }
    }
  }
  /* 计算规则 嵌套弹窗 */
  .calculate-openArea {
    /deep/ .el-dialog {
      width: 1190px;
      margin: 4.5vh auto 0 !important;
      box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
        0px 9px 28px 0px rgba(0, 0, 0, 0.05),
        0px 6px 16px -8px rgba(0, 0, 0, 0.08);
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }

    .calculate-openArea-div {
      background: #ffffff;
      border-radius: 10px;
      .openArea-div-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #d9d9d9;
        .openArea-div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }

        .openArea-div-top-img {
          width: 10px;
          height: 10px;
        }
      }

      .openArea-div-warning {
        width: 100%;
        height: 30px;
        background: rgba(249, 182, 60, 0.1);
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ed6d1f;
        line-height: 30px;
        padding: 0 24px;
        box-sizing: border-box;
      }

      .openArea-div-center {
        padding: 0 24px;
        box-sizing: border-box;

        /deep/ .el-tree-node__content {
          height: 40px;
        }

        /deep/ .el-tree-node__expand-icon.expanded {
          display: none;
        }

        /deep/ .el-tree-node__content > .el-tree-node__expand-icon {
          display: none;
        }

        /deep/ .el-tree-node__label {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }

      .openArea-div-button {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 24px;
        box-sizing: border-box;
        height: 52px;
        border-top: 1px solid #e9edf4;
        margin-top: 22px;

        .openArea-div-button-left,
        .openArea-div-button-right {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          text-align: center;
          line-height: 32px;
          cursor: pointer;
        }

        .openArea-div-button-right {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          margin-left: 8px;
          color: #ffffff;
        }
      }
    }
  }
  /* 删除弹出框 */
  .detele {
    /deep/ .el-dialog {
      height: 231px;
      width: 394px;
    }

    .detele-div {
      text-align: center;

      .detele-div-img {
        width: 56px;
        height: 56px;
      }

      .detele-div-title {
        height: 32px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
      }

      .detele-div-text {
        width: 319px;
        height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin: 0 auto;
        margin-top: 2px;

        margin-bottom: 18px;
      }

      .detele-div-text1 {
        width: 319px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin: 0 auto;
        margin-bottom: 8px;
      }

      .detele-div-button {
        width: 100%;
        height: 32px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        .detele-div-button-left,
        .detele-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
        }

        .detele-div-button-right {
          width: 88px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          margin-left: 10px;

          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }
  /* 编辑或者添加  嵌套弹窗保存 */
  .save {
    /deep/ .el-dialog {
      height: 231px;
      width: 394px;
    }

    .save-div {
      text-align: center;

      .save-div-img {
        width: 56px;
        height: 56px;
      }

      .save-div-title {
        height: 32px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
      }

      .save-div-text {
        width: 319px;
        height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin: 0 auto;
        margin-top: 2px;
      }

      .save-div-button {
        width: 100%;
        height: 32px;
        margin-top: 18px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        .save-div-button-left,
        .save-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
        }

        .save-div-button-right {
          width: 88px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          margin-left: 10px;

          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }
}
</style>
